"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _getReactNodeRef = require("../utilities/getReactNodeRef");
var _setRef = _interopRequireDefault(require("../utilities/setRef"));
var _useForkRef = _interopRequireDefault(require("../utilities/useForkRef"));
var _useIsomorphicLayoutEffect = _interopRequireDefault(require("../utilities/useIsomorphicLayoutEffect"));
function getContainer(container) {
  return typeof container === 'function' ? container() : container;
}
/**
 * The portal component renders its children into a new "subtree" outside of current component hierarchy.
 * The children of the portal component will be appended to the container specified. The component is used internally by the `Modal` and `Popper` components. You should consider using theses components if possible.
 *
 */
const Portal = /*#__PURE__*/_react.default.forwardRef(function Portal(props, forwardedRef) {
  const {
    children,
    container,
    onRendered,
    disablePortal = false
  } = props;
  const [mountNode, setMountNode] = _react.default.useState(null);
  const handleRef = (0, _useForkRef.default)((0, _getReactNodeRef.getReactNodeRef)(children), forwardedRef);
  (0, _useIsomorphicLayoutEffect.default)(() => {
    if (!disablePortal) {
      setMountNode(getContainer(container) || document.body);
    }
  }, [container, disablePortal]);
  (0, _useIsomorphicLayoutEffect.default)(() => {
    if (mountNode && !disablePortal) {
      (0, _setRef.default)(forwardedRef, mountNode);
      return () => {
        (0, _setRef.default)(forwardedRef, null);
      };
    }
    return undefined;
  }, [forwardedRef, mountNode, disablePortal]);
  (0, _useIsomorphicLayoutEffect.default)(() => {
    if (onRendered && (mountNode || disablePortal)) {
      onRendered();
    }
  }, [onRendered, mountNode, disablePortal]);
  if (disablePortal) {
    if (/*#__PURE__*/_react.default.isValidElement(children)) {
      const newProps = {
        ref: handleRef
      };
      return /*#__PURE__*/_react.default.cloneElement(children, newProps);
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, mountNode ? /*#__PURE__*/_reactDom.default.createPortal(children, mountNode) : mountNode);
});
var _default = exports.default = Portal;